import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, markRaw, onBeforeUnmount, shallowRef, type Component } from 'vue'
import { useRoute } from 'vue-router'
import router from '@/router'

type AppLayoutName = 'player' | 'default'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const layouts = shallowRef<Partial<Record<AppLayoutName, Component>>>({})

const getAppLayout = (layoutName: unknown): AppLayoutName =>
  layoutName === 'Player' ? 'player' : 'default'

const layout = computed(() => layouts.value[getAppLayout(route.meta.layout)] ?? null)

const loadLayout = async (layoutName: AppLayoutName) => {
  if (layouts.value[layoutName]) return

  try {
    const module = layoutName === 'player'
      ? await import('./layouts/Player/PlayerLayout.vue')
      : await import('./layouts/Default/DefaultLayout.vue')
    layouts.value = { ...layouts.value, [layoutName]: markRaw(module.default) }
  } catch (error) {
    console.error('Failed to load layout:', error)
  }
}

const removeLayoutGuard = router.beforeEach(async (to) => {
  await loadLayout(getAppLayout(to.meta.layout))
})

onBeforeUnmount(() => {
  removeLayoutGuard()
})

return (_ctx: any,_cache: any) => {
  return (layout.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), { key: 0 }))
    : _createCommentVNode("", true)
}
}

})